(function ($) {
/* ==========================================================================
   runs when HTML is ready
   ========================================================================== */

   function disableForumPostSubmitButton(btn) {
    btn.disabled = 'disabled';
    btn.innerHtml = '';
    btn.innerHTML = btn.textContent + '&nbsp;';
    var icon = document.createElement('i');
    icon.className = 'fa fa-spinner fa-spin';
    icon.setAttribute('aria-hidden', 'true');
    btn.appendChild(icon);
    
  }

  var wysiwygTable = $('.responsive-table');
  
  wysiwygTable.each(function () {
      var $table = $(this);

      if ($table.closest('.table-responsive').length === 0) {
          $table
              .addClass('table')
              .wrap('<div class="table-responsive"></div>');

          if ($table.attr('border') >= 0) {
              $table.addClass('table-bordered');
          }
      }
  });
  
  $(document).ready(function() {

    //Disable Forum Post Submit Button After First Form Submit.

    var form = document.querySelector('.post-form form');
    if (form !== null) {
    	form.addEventListener('submit', function (e) {
    		var submitButton = this.querySelector('.btn[type="submit"]');
    		if (submitButton !== null) {
    			disableForumPostSubmitButton(submitButton);
    		}
      });
      
      //Member directory search form hide additional location search if searching for users outside of the US.
      var $countryDropdown = $('#directory-search-form').find('#Country');
      var $usLocationSearch = $('#us-location-search');
      if ($countryDropdown.length > 0) {
      	if ($countryDropdown.val() !== 'US') {
      		$('#us-location-search').hide();
      	}
      	$countryDropdown.change(function () {
      		if ($usLocationSearch.length > 0) {

      			$usLocationSearch.toggle($countryDropdown.val() === "US");

      		}
      	});
      }
    }

    $('.raw-embed').fitVids({ customSelector: 'iframe[src*="google.com"]' });

    

    setHeight($(".feature-box"));

    $(".flexnav").flexNav({
      'animationSpeed' : 250, // default drop animation speed
      'transitionOpacity': true, // default opacity animation
      'buttonSelector': '.menu-button', // default menu button class
      'hoverIntent': true, // use with hoverIntent plugin
      'hoverIntentTimeout': 150, // hoverIntent default timeout
      'calcItemWidths': false, // dynamically calcs top level nav item widths
      'hover': true // would you like hover support?
    });

    navStretch(7); //pass the number of menu items in navbar

    offCanvasNavigation();

    $('.flexslider').flexslider({
      animation: "slide"
    });

    // browser window scroll (in pixels) after which the "back to top" link is shown
    var offset = 300,
      //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
      // offset_opacity = 1200,
      //duration of the top scrolling animation (in ms)
      scroll_top_duration = 500,
      //grab the "back to top" link
      $back_to_top = $('.cd-top');

    //hide or show the "back to top" link
    $(window).scroll(function(){
      ( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
      // if( $(this).scrollTop() > offset_opacity ) {
      //   $back_to_top.addClass('cd-fade-out');
      // }
    });

    //smooth scroll to top
    $back_to_top.on('click', function(event){
      event.preventDefault();
      $('body,html').animate({
        scrollTop: 0 ,
          }, scroll_top_duration
      );
    });
    // Member forum table collapse button
    $('.btn-collapse').on('click', function (e) {
      var $btn = $(this),
        toggleText = $btn.find('.toggle-text').text();
   
      $btn
        .find('.toggle-text')
        .text($btn.data('replace'))
        .end()
        .toggleAttrTrueFalse('aria-expanded');

      $btn.data('replace', toggleText);
    });
});

/* ==========================================================================
   runs when everything is loaded
   ========================================================================== */

  $(window).load(function() {
  // window.onload = function () {

      setTimeout(function(){
        centerScale($(".feature-image"));
      }, 10);

      // sets off canvas nav to full height when active
      setToWindowHeight($(".l-site-nav"));

      vCenterSingle(); //terrible vertical centering of text on home header image

      // equalHeight($(".sidebar-white")); //equalize section promo boxes on homepage

      equalHeightSidebar($(".equalizer"));

      equalHeight($(".equalizeIt"));
      vCenter($(".issue-tile > .tile-img"));
      
  });

/* ==========================================================================
   runs on resize
   ========================================================================== */

  // var resizeCheck;

  $(window).resize(function(){

      // equalHeight($(".feature-col"));
      setTimeout(function(){
        setHeight($(".feature-box"));
        centerScale($(".feature-image"));
      }, 10);

      navStretch(7); //pass the number of menu items in navbar

      // sets off canvas nav to full height when active
      setToWindowHeight($(".l-site-nav"));

      vCenterSingle(); //terrible vertical centering of text on home header image

      equalHeightSidebar($(".equalizer"));

      equalHeight($(".equalizeIt"));
      vCenter($(".issue-tile > .tile-img"));


  });

/* ==========================================================================
   function definitions
   ========================================================================== */

  // Sets off canvas nav to full height when active
  function setToWindowHeight(navBlock) {
    if ( $( window ).width() < 992 ) { //should line up with width mobile nav is triggered
      $(navBlock).height($( document ).height());
    }
    else {
      $(navBlock).height('auto');
    }
  }

  function scrollShrink() {
      window.addEventListener('scroll', function(e){
          var distanceY = window.pageYOffset || document.documentElement.scrollTop,
              shrinkOn = 115,
              header = document.querySelector("nav-wrap");
          if (distanceY > shrinkOn) {
              $(".nav-wrap").addClass("smaller");
          } else {
              if ($(".nav-wrap").hasClass("smaller")) {
                  $(".nav-wrap").removeClass("smaller");
              }
          }
      });
  }

  function mergenav() {
    $('#main-navbar-collapse').append( $('.utility-nav-pills') );
    $('.navbar-style').append( $('#subnav-collapse') );
    if ($('div#subnav-collapse').length) {
      // collapses subnav if displaying mobile styles
      $( "#subnav-collapse" ).removeClass( "in" );
    }
    else {
      $( ".subnav-toggle").addClass( "hidden" );
    }
  }

  function splitnav() {
    $('#desktop-utility').append( $('.utility-nav-pills') );
    $('#subnav-holder').append( $('#subnav-collapse') );
    $( "#subnav-collapse" ).addClass( "in" );
    $("#subnav-collapse").css("height", "auto");
  }

  // make sure main menu is collpased when viewing subnav on mobile
  $( ".subnav-toggle" ).click(function( event ) {
      event.preventDefault();
      $( "#main-navbar-collapse" ).removeClass( "in" );
  });

  // make sure subnav is collpased when viewing main menu on mobile
  $( ".navbar-toggle" ).click(function( event ) {
      event.preventDefault();
      $( "#subnav-collapse" ).removeClass( "in" );
  });

  //equalizes heights of sidebars
  function equalHeightSidebar(group) {
    // resets sidebar body height
    group.each(function() {
      $(this).children(".sidebar-body").height("auto");
    });
    if ( $( window ).width() > 767 ) { //should line up with width mobile nav is triggered
      tallest = 0;
      group.each(function() {
        thisHeight = $(this).height();
        if(thisHeight > tallest) {
          tallest = thisHeight;
        }
      });
      group.each(function() {
        thisHeight = $(this).height();
        growBy = tallest - thisHeight;
        bodyHeight = $(this).children(".sidebar-body").height();
        $(this).children(".sidebar-body").height(bodyHeight + growBy);
      });
    }
  };

  //generic height equlizer
  function equalHeight(group) {
    group.height("auto");
    if ( $( window ).width() > 767 ) { //should line up with width mobile nav is triggered
      tallest = 0;
      group.each(function() {
        thisHeight = $(this).outerHeight();
        if(thisHeight > tallest) {
          tallest = thisHeight;
        }
      });
      group.outerHeight(tallest);
    }
  };

  //slider text centering
  function vCenter(textBlock) {
    marginOffest = 0;
    
    textBlock.each(function() {
      $(this).css({
       'margin-top': 24
      });
      if ( $( window ).width() > 767 ) { //should line up with width mobile nav is triggered
        slideHeight = $(this).first().parent().height();
      //console.log("slideHeight = "+slideHeight)
        thisHeight = $(this).outerHeight();
        newMargin = ((slideHeight  - marginOffest - thisHeight)/2);
        $(this).css({
         'margin-top': newMargin
        });
      }
    });
  };

  //single item text centering on homepage
  function vCenterSingle() {

    if ( $( window ).width() > 767 ) { //should line up with width mobile nav is triggered
      slideHeight = $(".header-image").height();
      thisHeight = $(".header-intro").outerHeight();
      newMargin = ((slideHeight - thisHeight)/2);
      $(".header-intro").css({
       'bottom': newMargin
      });
    }
    else {
      $(".header-intro").css({
       'bottom': 0
      });
    }
  };

  function navStretch(navNumber) {
    if ( $( window ).width() > 991 ) { //should line up with width mobile nav is triggered
      var navWidth = $('.site-nav-links').width() - 25;
    //   console.log("overall width " + navWidth);
      var childrenWidth = 0;
      var count = 0;
      $('.site-nav-links > li').each(function() {
        count++;
        // console.log("child width " + count + ": " + $(this).outerWidth());
        childrenWidth += $(this).outerWidth();
      });
    //   console.log("children width: " + childrenWidth);
    //   console.log("-------------------------");
      var navGap = (navWidth - childrenWidth) / navNumber; //this divides remainder by number of menu items
      $('.site-nav-links > li').each(function() {
        $(this).css({
         'margin-right': Math.floor(navGap)
        });
      });
      $('.site-nav-links').fadeTo(300, 1.0);
      $('.utility-nav-links').fadeTo(300, 1.0);
    }
    else {
      $('.site-nav-links > li').each(function() {
        $(this).css({
         'margin-right': 0
        });
      });
    }
  };

  // set image container height to match textbox
  function setHeight(featureBox) {
    if ( $( window ).width() > 767 ) {
      featureBox.each(function() {
        textHeight = $(this).find(".feature-text").height();
        $(this).find(".img-wrap").css({
          'height' : textHeight
        });
      });
    }
    else {
      featureBox.each(function() {
        $(this).find(".img-wrap").css({
          'height' : 250
        });
      });
    }
  };

  //image scale and center image to fill wrapper
  function centerScale(theImage) {
    theImage.each(function() {
      parentHeight = $(this).parent().height();
      parentWidth = $(this).parent().width();

      thisHeight = $(this).height();
      thisWidth = $(this).width();

      if(thisHeight < parentHeight){
        $(this).css({
         'height': '100%',
         'width' : 'auto'
        });
        hShift = 1;
      }

      if(thisWidth < parentWidth){
        $(this).css({
         'height': 'auto',
         'width' : '100%'
        });
        hShift = 0;
      }

      if (typeof hShift === 'undefined'){
        hShift = 0;
      }

      // horizontal centering
      if (hShift == 1){
        thisWidth = $(this).width();
        leftMargin = (parentWidth - thisWidth)/2;
        $(this).css({
         'margin-top' : 0,
         'margin-left' : leftMargin + 'px'
        });
      }

      // vertical centering
      if (hShift == 0){
        thisHeight = $(this).height();
        topMargin = (parentHeight - thisHeight)/2;
        $(this).css({
         'margin-top' : topMargin + 'px',
         'margin-left' : 0
        });
      }

    });
  };

/*-------------------------------------------------------------------

    Off canvas navigation stuff

-------------------------------------------------------------------*/
var navInClass = 'site-nav-showing';
// Add/Remove navInClass to body tag when needed
toggleOffCanvas = function(){
    if(!$('body').hasClass(navInClass)){
        $('body').addClass(navInClass);
    } else {
        $('body').removeClass(navInClass);
    }
}
function offCanvasNavigation(){
    var touchStartX;
    var touchStartY;
    
    // Build overlay that covers up the page content so it can't be interacted with when off canvas nav is enabled
    $('.l-off-canvas-wrap').prepend('<div class="off-canvas-overlay"></div>');
    
    // Get X location of user touch
    $('body').bind('touchstart', function(e) {
        touchStartX = e.originalEvent.touches[0].clientX;
    });
    
    // Get Y location of touch is user touches off-canvas-overlay
    $('.off-canvas-overlay').bind('touchstart', function(e) {
        touchStartY = e.originalEvent.touches[0].clientY;
    });
    
    // If user is swiping left to right disable page scrolling and close off canvas nav
    $('body').bind('touchmove', function(e) {
        var touchRight = e.originalEvent.changedTouches[0].clientX;
        
        if (touchStartX + 50 < touchRight && $('body').hasClass(navInClass)) {
            $('body').removeClass(navInClass);
        }
    });
    
    // If user is swiping down on the off-canvas-overlay
    $('.off-canvas-overlay').bind('touchmove', function(e) {
        var touchDown = e.originalEvent.changedTouches[0].clientY;
        
        if (touchStartY + 10 > touchDown || touchStartY + 10 < touchDown && $('body').hasClass(navInClass)) {
            $('body').removeClass(navInClass);
        }
    });
    
    // If user clicks (or taps) close the off canvas nav
    $('.off-canvas-menu-btn, .off-canvas-overlay').on('click', function(){
        toggleOffCanvas();
    });
}

// Toggle attribute true/false method
$.fn.toggleAttrTrueFalse = function (elAttr) {
  $(this).attr(elAttr,
      $(this).attr(elAttr) === 'false' ? 'true' : 'false'
  );
};

$('html').removeClass('no-js').addClass('js-active');


})(jQuery);